import axios from "axios";
import { AUTH_API_BASE_URL } from "../../api-config";

export const refreshToken = async (token) => {
  try {
    const response = await axios.post(`${AUTH_API_BASE_URL}/extendToken`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data.token;
  } catch (error) {
    console.error("Error in refreshToken:", error);
    throw error;
  }
};
